const constants = require("./constants");

// type -> translation (not fixed)
module.exports = {
  STUDENT_DOCS: {
    [constants.university_acceptance_letter]: "universityAcceptanceLetter",
    [constants.ie_student]: "studentRegistrationContract",
  },
  EMPLOYED_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.deduction_certificate]: "deductionCertificate",
    [constants.firstMonthPayslip]: "firstMonthPayslip",
    [constants.secondMonthPayslip]: "secondMonthPayslip",
    [constants.thirdMonthPayslip]: "thirdMonthPayslip",
    [constants.employment_contract]: "employmentContract",
  },
  DOMESTIC_WORKER_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.deduction_certificate]: "deductionCertificate",
    [constants.annual_payment_certificate]: "annualPaymentCertificate",
    [constants.employment_contract]: "employmentContract",
  },
  FREELANCER_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.deduction_certificate]: "deductionCertificate",
    [constants.fractioned_tax_return]: "lastFractionatedTaxReportModel130",
    [constants.quarterly_vat]: "lastQuarterlyVATTaxForm303",
    // [constants.firstMonthPayslip]: "firstMonthPayslip",
    // [constants.secondMonthPayslip]: "secondMonthPayslip",
    // [constants.thirdMonthPayslip]: "thirdMonthPayslip",
    // [constants.employment_contract]: "employmentContract",
  },
  RETIRED_DOCS: {
    [constants.comprehensive_certificate_of_benefits]:
      "comprehensiveCertificateOfBenefits",
    [constants.last_revalorization_letter]: "lastRevalorizationLetter",
    // #TODO: add model 100 also
    [constants.last_annual_tax_report]: "lastAnnualTaxReportModel100",
  },
  UNEMPLOYED_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.comprehensive_certificate_of_benefits]:
      "comprehensiveCertificateOfBenefits",
    // [constants.firstMonthPayslip]: "firstMonthPayslip",
    // [constants.secondMonthPayslip]: "secondMonthPayslip",
    // [constants.thirdMonthPayslip]: "thirdMonthPayslip",
  },
  SELF_EMPLOYED_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.deduction_certificate]: "deductionCertificate",
    [constants.fractioned_tax_return]: "lastFractionatedTaxReportModel130",
    // [constants.firstMonthPayslip]: "firstMonthPayslip",
    // [constants.secondMonthPayslip]: "secondMonthPayslip",
    // [constants.thirdMonthPayslip]: "thirdMonthPayslip",
    [constants.corporate_tax_return]: "lastYearsCorporateTaxReturn",
    [constants.corporate_balance_sheet]: "lastYearsCorporateBalanceSheet",
    [constants.corporate_PL]: "lastYearsCorporatePAndL",
    [constants.companyIncorporationDocuments]: "companyIncorporationDocuments",
  },
  PUBLIC_SERVANT_DOCS: {
    [constants.previous_working_life_certificate]: "workingLifeCertificate",
    [constants.income_tax_return]: "lastAnnualTaxReportModel100",
    [constants.firstMonthPayslip]: "firstMonthPayslip",
    [constants.secondMonthPayslip]: "secondMonthPayslip",
    [constants.thirdMonthPayslip]: "thirdMonthPayslip",
    [constants.contribution_bases]: "contributionBases",
    [constants.appointment_of_a_civil_servant]: "appointmentOfSCivilServant",
    [constants.officialappointmentNotice]: "officialappointmentNotice",
  },
  MILITARY_DOCS: {
    [constants.certificate_of_Professional_Life]:
      "certificateOfServicesRendered",
  },
  CLAVE_DOCS: [
    constants.previous_working_life_certificate,
    constants.income_tax_return,
    constants.deduction_certificate,
    constants.fractioned_tax_return,
    constants.comprehensive_certificate_of_benefits,
    "workingLifeCertificate",
    "lastAnnualTaxReportModel100",
    "deductionCertificate",
    "lastFractionatedTaxReportModel130",
    "comprehensiveCertificateOfBenefits",
  ],
  PROTECTED_HOUSING: {
    [constants.regulatory_agreement_in_case_of_divorce_separation]:
      "regulatoryAgreementInCaseOfDivorceSeparation",
    [constants.revalued_pension_certificate]: "revaluedPensionCertificate",
    [constants.family_book_marriage_civil_partnership_birth_certificate]:
      "familyBookMarriageCivilPartnershipBirthCertificate",
    [constants.certificate_proving_disability_status]:
      "certificateProvingDisabilityStatus",
    [constants.certificate_of_residency_registration]:
      "certificateOfResidencyRegistration",
    [constants.no_special_circumstances]: "noSpecialCircumstances",
  },
  COMPANY_DOCS: {
    [constants.corporate_tax_return]: "lastYearsCorporateTaxReturn",
    [constants.constitution_document]: "constitutionDocument",
    [`${constants.quarterly_vat} Q1`]: "lastQuarterlyVATTaxForm303Q1",
    [`${constants.quarterly_vat} Q2`]: "lastQuarterlyVATTaxForm303Q2",
    [`${constants.quarterly_vat} Q3`]: "lastQuarterlyVATTaxForm303Q3",
    [`${constants.quarterly_vat} Q4`]: "lastQuarterlyVATTaxForm303Q4",
  },
};
